import Vue from "vue";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;
const VueScrollTo = require("vue-scrollto");

Vue.use(VueScrollTo, {
  container: "body",
  duration: 900,
  easing: "ease",
  offset: -80,
  cancelable: true,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
